import React, { useEffect, useState, useContext } from "react";
import Contexto from "../context/Contexto";
import ManejoUsuario from "../components/menejoUsuario";
import ManejoUsuarioFull from "../components/menejoUsuarioFull";
function Paneldecontrol() {
  const {
    seteos,
    cliente,
    loguearUsuario,
    mandarMensajes,
    dameMiCurso,
    productos,
    dameBaseDeUsuarios,
    baseCompleta,
    DaleElCurso,
  } = useContext(Contexto);
  const [admin, setAdmin] = useState(true);
  const [baseLoca, setBaseLoca] = useState([]);
  const [verUno, setVerUno] = useState(null);

  useEffect(() => {
    if (cliente) {
      setAdmin(true);
      if (baseCompleta.length == 0) {
        dameBaseDeUsuarios();
      }
    }
  }, [cliente]);

  useEffect(() => {
    if (baseCompleta) {
      console.log("tiene cosutas la base: ", baseCompleta.length);
    }
  }, [baseCompleta]);

  let filtrame = () => {
    let criterio = document.getElementById("elegido").value;
    let filtradito;
    if (criterio.includes("@")) {
      filtradito = baseCompleta.filter((element) => element.email == criterio);
    } else {
      filtradito = baseCompleta.filter((element) => element[criterio]);
    }
    if (filtradito.length == 0) {
      filtradito = baseCompleta.filter((element) => element.uid == criterio);
    }

    setBaseLoca(filtradito);
    console.log("setVerUno", verUno);
  };
  let mostrame = (uuid) => {
    console.log("uid-->", uuid);
    let usuarioFUll = baseCompleta.find((element) => element.uid == uuid);
    console.log("FULL -->", usuarioFUll);
    setVerUno(usuarioFUll);
  };
  let cerrar = () => {
    setVerUno(null);
  };

  let daleCurso = (dato) => {
    DaleElCurso(dato);
  };
  return (
    <>
      <input type="text" id="elegido" />
      <button onClick={filtrame}>Filtrame</button>

      {baseLoca.map((item, i) => {
        return <ManejoUsuario key={item.uid} {...item} mostrame={mostrame} />;
      })}
      {verUno && (
        <ManejoUsuarioFull
          {...verUno}
          cerrar={cerrar}
          daleCurso={daleCurso}
        ></ManejoUsuarioFull>
      )}
    </>
  );
}

export default Paneldecontrol;
